export default __webpack_public_path__ + "static/media/envelope.e4cacd46.svg";